export default {"src":"/_next/static/media/gold_heart_filled.36229b2d.svg","height":21,"width":23,"blurWidth":0,"blurHeight":0};